/**
 * Components used for $artistSubscription event bus
 *
 * ./components/Artists/TheFollowArtistButton
 * ./components/UnfollowArtistModal
 * ./components/Artists/TheArtistSubscriptionPanel
 *
 * List of events
 *
 * subscribe
 * hasUnfollowed
 * unfollow
 */
import Vue from "vue";

Vue.prototype.$artistSubscription = new Vue();

Vue.prototype.$favoriteArtwork = new Vue();
